const BADGE_DETAIL_PARAMS = {
    BADGE_ID: 'badge',
    JOURNEY_ID: 'journey',
    LEVEL_BADGE_ID: 'levelBadge',
} as const;

export default BADGE_DETAIL_PARAMS;
